import {Injectable, Inject} from '@angular/core';
import {Observable, of} from "rxjs";
import {IAuthorizationPolicyConfiguration} from "../auth/auth.policy.configuration";

import {tap} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class AppConfigService {

  private _config: object;
  private _baseURL: string;
  private _odataEndpoint: string = "/odataWebClient";
  private _webapiEndpoint: string = "/api";
  private _authURL: string;
  private EM_GLOBAL_VARS: string = "__central_management_global_vars__";
  private _cachedAutorizationPolicyConfiguration : IAuthorizationPolicyConfiguration;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  public getAppConfig() {
    this._baseURL = window[this.EM_GLOBAL_VARS].baseDataUrl;
    this._authURL = window[this.EM_GLOBAL_VARS].baseTokenUrl;
    if (window.location.host !== 'localhost:8282') {
      this._baseURL = window.location.origin + '/' + this._baseURL;
      this._authURL = window.location.origin + '/' + this._authURL;
    }
    const data = {
      BASE_DATA_URL: this._baseURL, BASE_TOCKEN_URL: this._authURL
    };
    this._config = data;
    return data;
  }

  getOdataURL() {
    return this._baseURL + this._odataEndpoint;
  }

  getWebapiURL() {
    return this._baseURL + this._webapiEndpoint;
  }

  getBaseURL() {
    return this._baseURL;
  }

  getAuthURL() {
    return this._authURL;
  }

  replaceCaseInSensitive(str: string, strToReplace: string, strWith: string) {
    const esc = strToReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const reg = new RegExp(esc, 'ig');
    return str.replace(reg, strWith);
  }

  public GetAuthorizationPolicyConfiguration(): Observable<IAuthorizationPolicyConfiguration> {
    if (this._cachedAutorizationPolicyConfiguration) {
      return of(this._cachedAutorizationPolicyConfiguration);
    } else {
      return this.http.get<IAuthorizationPolicyConfiguration>(this.getWebapiURL() + "/ApplicationUser/GetAuthorizationPolicyConfiguration")
        .pipe(tap(value => this._cachedAutorizationPolicyConfiguration = value) );
    }


  }
}

